import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, viewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { NotificationBarService } from 'src/app/services/notification-bar.service';

interface TextInputeditorOptions {
	name: string;
	label?: string;
	value?: string;
	createField?: boolean;
	buttonText?: string;
	placeholder?: string;
	hint?: string;
	callback?: (val: string) => Promise<string | undefined>;
}

@Component({
	selector: 'app-textInputeditor-dialog',
	templateUrl: './textInputeditor-dialog.component.html',
	styleUrls: ['./textInputeditor-dialog.component.scss'],
	standalone: false,
})
export class TextInputeditorDialogComponent {
	public name: string = 'Text';
	public label: string = 'Text';
	public value: string = '';
	public buttonText: string = 'Update';
	public placeholder: string = '';
	public hint: string = '';

	public isUpdating = false;

	constructor(
		public dialogRef: MatDialogRef<TextInputeditorDialogComponent>,
		private notify: NotificationBarService,
		private translate: TranslateService,
		@Inject(MAT_DIALOG_DATA) public data: TextInputeditorOptions
	) {
		this.name = data.name;
		if (data.label) {
			this.label = data.label;
		} else {
			this.label = data.name;
		}
		if (data.value) {
			this.value = data.value;
		}
		if (data.createField) {
			this.buttonText = this.translate.instant('common.create');
		} else {
			this.buttonText = this.translate.instant('common.update');
		}
		if (data.buttonText) {
			this.buttonText = data.buttonText;
		}
		if (data.placeholder) {
			this.placeholder = data.placeholder;
		}
		if (data.hint) {
			this.hint = data.hint;
		}
	}

	readonly autosize = viewChild.required<CdkTextareaAutosize>('autosize');

	public async update(text: string) {
		this.isUpdating = true;
		let result: any = undefined;

		if (this.data.callback) {
			try {
				await this.data.callback(text);
			} catch (err) {
				console.log(err);
				if (err instanceof Error) {
					result = err.message;
				} else if (err instanceof HttpErrorResponse) {
					result = err.error.message || this.translate.instant('dialogs.textInputEditor.serviceUnavailable');
				} else {
					result = err;
				}
			}
		}

		console.log(result);
		if (result === undefined) {
			this.dialogRef.close(text);
		} else {
			this.notify.notify('error', this.translate.instant('common.error'), result);
		}

		this.isUpdating = false;
	}

	public cancel() {
		this.dialogRef.close();
	}
}
